<template>
    <div v-if="options.length <= radioLimit" class="container w-full ml-0">
        <input
            style="opacity: 0; width: 0; height: 0; float: left"
            required
            tabindex="-1"
            :name="name"
            :value="selected"
            @input="$event.target.value = selected"
        />
        <div class="row row-cols-4">
            <div
                v-for="user in options"
                :key="user.id"
                role="button"
                class="d-flex align-items-center rounded p-2"
                :class="selected === user.id ? 'is-selected' : ''"
                style="min-height: 60px"
                @click.prevent="selected = user.id"
            >
                <img :src="user.avatar" class="avatar-image" />
                <div>
                    {{ user.name }}
                </div>
            </div>
        </div>
    </div>
    <div v-else class="w-full">
        <v-select
            v-model="selected"
            :options="options"
            label="name"
            :reduce="(option) => option.id"
            placeholder="Välj en"
        >
            <template #search="{ attributes, events }">
                <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    :required="!selected"
                />
            </template>
            <template #option="user">
                <div class="d-flex align-items-center">
                    <img :src="user.avatar" class="avatar-image" />
                    <div>{{ user.name }}</div>
                </div>
            </template>
            <template #selected-option="user">
                <div class="d-flex align-items-center">
                    <img :src="user.avatar" class="avatar-image" />
                    <div>{{ user.name }}</div>
                </div>
            </template>
        </v-select>
        <input type="hidden" :name="name" :value="selected || ''" />
    </div>
</template>

<style lang="scss" scoped>
.is-selected {
    background-color: #f5f5f5;
}

.avatar-image {
    width: 2em;
    height: 2em;
    object-fit: contain;
    border-radius: 50%;
    margin-right: 1em;
}
</style>

<script setup>
import { onMounted, ref, watch } from "vue";
const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
    options: {
        type: Array,
        required: true,
    },
    name: {
        type: String,
        required: true,
    },
    salespersonId: {
        type: Number,
        default: null,
    },
    isLivewireComponent: {
        type: Boolean,
        default: false,
    },
    radioLimit: {
        type: Number,
        default: 24,
    },
});
const selected = ref(props.salespersonId);
const wire = ref(null);
function emitToLivewire() {
    if (props.isLivewireComponent) {
        wire.value.$set("salesperson_id", selected.value);
    }
}
watch(selected, () => {
    emit("update:modelValue", selected.value);
    emitToLivewire();
});
watch(
    () => props.salespersonId,
    () => {
        if (selected.value == props.salespersonId) {
            return;
        }
        selected.value = props.salespersonId;
    }
);
onMounted(() => {
    if (props.isLivewireComponent) {
        document.addEventListener("livewire:initialized", () => {
            wire.value = Livewire.first();
            emitToLivewire();
        });
    }
});
</script>
